<template>
  <el-dialog
    title="Grupo de tipos de elementos"
    :model-value="visible"
    width="900px"
    destroy-on-close
    @close="emits('cerrar-modal')"
  >
    <el-row :gutter="20">
      <custom-data
        :span="4"
        label="Codigo"
        :data="elementoGrupo.Codigo"
      />
      <custom-input
        v-model="elementoGrupo.Descripcion"
        label="Descripción"
        :spanColumn="16"
        :settings="{
          placeholder: 'Descripción',
          maxlength: 300,
        }"
      />
    </el-row>
    <br />
    <custom-title>Tipos de elementos</custom-title>
    <br />
    <el-row :gutter="20">
      <el-col :span="24">
        <el-transfer
          v-model="elementosTiposSeleccionados"
          :data="elementosTipos"
          :titles="['Disponibles', 'Asignados']"
        />
      </el-col>
    </el-row>
    <custom-confirm-buttons
      confirmText="Guardar"
      :confirmDisabled="saveDisabled"
      @onCancel="emits('cerrar-modal')"
      @onConfirm="save"
    />
  </el-dialog>
</template>

<script setup>
import {
  computed,
  ref,
  onBeforeMount,
} from 'vue';
import { storeToRefs } from 'pinia';
import {
  ElMessage,
  ElMessageBox,
} from 'element-plus';
import CustomData from '@/shared/components/custom_data.vue';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import { useElementoGrupoStore } from '@/stores/elemento_grupo/elemento_grupo_store.js';
import { useElementoTipoStore } from '@/stores/elemento_tipo/elemento_tipo_store.js';

const elementoGrupoStore = useElementoGrupoStore();
const { elementoGrupo } = storeToRefs(elementoGrupoStore);

const elementoTipoStore = useElementoTipoStore();

const elementosTiposSeleccionados = ref([]);

const emits = defineEmits(['cerrar-modal']);

defineProps({
  visible: { type: Boolean, default: false },
});

const elementosTipos = computed(() => {
  return elementoTipoStore.getActiveReducedProductTypeList.map((i) => ({
    key: i.Codigo,
    label: i.Descripcion,
    disabled: false,
  }));
});

const saveDisabled = computed(() => {
  return elementoGrupo.value.Descripcion && elementoGrupo.value.Descripcion.length === 0;
});

const save = () => {
  console.log(elementosTiposSeleccionados.value);
  ElMessageBox.confirm(`¿Quiere guardar el grupo de elementos?`, 'Confirmación', {
    confirmButtonText: 'Si',
    cancelButtonText: 'No',
    type: 'warning',
  })
    .then(async () => {
      elementoGrupo.value.ElementoGrupoDetalle = [
        ...elementoTipoStore.getActiveProductTypeList.filter((i) =>
          elementosTiposSeleccionados.value.includes(i.Codigo),
        ),
      ];

      await elementoGrupoStore.saveElementoGrupo();
      await elementoGrupoStore.findAllElementosGrupoHTTP({ page: 0 });
      ElMessage({
        type: 'success',
        message: 'Grupo de elementos guardado!',
      });
    })
    .catch(() => {});

  emits('cerrar-modal');
};

onBeforeMount(() => {
  elementosTiposSeleccionados.value = [
    ...elementoGrupo.value.ElementoGrupoDetalle.map((i) => i.CodigoElementoTipo),
  ];
});
</script>

<style scoped>
:deep(.el-transfer) {
  display: flex !important;
  width: 100% !important;
  gap: 12px;
}

:deep(.el-transfer-panel) {
  flex: 1 !important;
  width: 50% !important;
  max-width: none !important;
  min-width: 0;
}

:deep(.el-transfer-panel__body) {
  height: 300px;
  width: 100%;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

:deep(.el-transfer-panel__list) {
  width: 100%;
  padding-right: 0;
}

:deep(.el-transfer-panel__item) {
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(.el-transfer-panel__content) {
  width: 100%;
}
</style>
